export default "__VITE_ASSET__Cka$C6Uq__"